import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected baseUrl = environment.apiConfig.webApiUri;

  constructor(protected http: HttpClient) {}
}
